"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokens = exports.TextFieldWidth = exports.TextFieldSize = exports.InputHeight = void 0;
var _globalTokens = require("../../../shared/global-tokens");
var _icon = require("../../../components/media/icon/icon.tokens");
var tokens = exports.tokens = {
  color: {
    background: {
      default: _globalTokens.globalColor.background.neutral['1'],
      disabled: _globalTokens.globalColor.background.disabled['1']
    },
    icon: {
      default: _icon.tokens.color.default
    }
  },
  border: {
    default: "".concat(_globalTokens.globalBorder.width.thin, " solid ").concat(_globalTokens.globalColor.border.enabled),
    active: "".concat(_globalTokens.globalBorder.width.thick, " solid ").concat(_globalTokens.globalColor.border.active),
    focus: "".concat(_globalTokens.globalBorder.width.thick, " solid ").concat(_globalTokens.globalColor.border.active),
    error: "".concat(_globalTokens.globalBorder.width.thick, " solid ").concat(_globalTokens.globalColor.border.error),
    disabled: "".concat(_globalTokens.globalBorder.width.thick, " solid ").concat(_globalTokens.globalColor.border.disabled)
  },
  borderRadius: _globalTokens.globalBorder.radius['3'],
  size: {
    height: {
      small: '32px',
      large: '44px'
    },
    innerHeight: {
      small: '30px',
      large: '42px'
    },
    width: {
      fixed: '320px',
      flex: ''
    }
  },
  padding: {
    noIcon: "".concat(_globalTokens.globalSpacing['200'], " ").concat(_globalTokens.globalSpacing['400']),
    rightIcon: "".concat(_globalTokens.globalSpacing['200'], " ").concat(_globalTokens.globalSpacing['300'], " ").concat(_globalTokens.globalSpacing['200'], " ").concat(_globalTokens.globalSpacing['400']),
    leftIcon: "".concat(_globalTokens.globalSpacing['200'], " ").concat(_globalTokens.globalSpacing['400'], " ").concat(_globalTokens.globalSpacing['200'], " ").concat(_globalTokens.globalSpacing['300']),
    leftAndRightIcon: "".concat(_globalTokens.globalSpacing['200'], " ").concat(_globalTokens.globalSpacing['300'])
  }
};
var TextFieldWidth = exports.TextFieldWidth = /*#__PURE__*/function (TextFieldWidth) {
  TextFieldWidth["FLEX"] = "flex";
  TextFieldWidth["FIXED"] = "fixed";
  return TextFieldWidth;
}({});
var TextFieldSize = exports.TextFieldSize = /*#__PURE__*/function (TextFieldSize) {
  TextFieldSize["SMALL"] = "small";
  TextFieldSize["LARGE"] = "large";
  return TextFieldSize;
}({});
var InputHeight = exports.InputHeight = /*#__PURE__*/function (InputHeight) {
  InputHeight["SMALL"] = "small";
  InputHeight["LARGE"] = "large";
  return InputHeight;
}({});